import { RootState } from '../../types/RootState'

class OnboardingSelectors {
  getOnboardingStep = (state: RootState) => state.onboarding.onboardingStep
}

export default new OnboardingSelectors()
